import { render, staticRenderFns } from "./ChangeCategory.vue?vue&type=template&id=e36b83fa&scoped=true"
import script from "./ChangeCategory.vue?vue&type=script&lang=js"
export * from "./ChangeCategory.vue?vue&type=script&lang=js"
import style0 from "./ChangeCategory.vue?vue&type=style&index=0&id=e36b83fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36b83fa",
  null
  
)

export default component.exports